
// NATIVE 
import * as React from 'react';


// INSTALLED 
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { Grid, Typography, Chip, Box, Divider } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useSelector } from 'react-redux';
// import { SurveyImage } from '../../../configuracion-encuestas';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { SurveyImage } from '../../../configuracion-encuestas/components/FormSurvey';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(3),
  },
}));



export const DetailRatingsDevice = (props: any) => {

  const { open, handleCloseModalDetail } = props;

  // REDUX 
  const { device }: any = useSelector((state: any) => state.ratingsDevices);




  const handleClose = () => {
    handleCloseModalDetail(false);
  };


  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="detail-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle sx={{ m: 0, p: 2, fontWeight: 700, display: 'flex', alignItems: 'center' }} id="detail-dialog-title">
          <Box sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(105, 108, 255, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 2,
                    color: '#696cff'
                }}>
                    <VisibilityOutlinedIcon sx={{ fontSize: 24 }} />
                        {/* {isViewMode ? <VisibilityOutlinedIcon sx={{ fontSize: 24 }} /> : isEditMode ? <EditOutlinedIcon sx={{ fontSize: 24 }} /> : <SaveOutlinedIcon sx={{ fontSize: 24 }} />} */}
          </Box>
          <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#32475CDE', lineHeight: 1.2 }}>
                  Detalle del Dispositivo
              </Typography>
              <Typography variant="body2" sx={{ color: '#32475C99', mt: 0.5 }}>
                  Información del dispositivo de calificación
              </Typography>
          </Box>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        {device ? (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" color="textSecondary">Nombre</Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>{device.name}</Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" color="textSecondary">Código</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.main', fontFamily: 'monospace' }}>
                {device.code}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" color="textSecondary">Descripción</Typography>
              <Typography variant="body1">{device.description || 'Sin descripción'}</Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" color="textSecondary">Requiere Usuario</Typography>
              <Box sx={{ mt: 0.5 }}>
                {device.isUserRequired ? (
                  <Chip label="SÍ" color="primary" size="small" />
                ) : (
                  <Chip label="NO" color="default" size="small" />
                )}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" color="textSecondary">Estado</Typography>
              <Box sx={{ mt: 0.5 }}>
                {device.status === 1 ? (
                  <Chip label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} size="small" />
                ) : (
                  <Chip label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} size="small" />
                )}
              </Box>
            </Grid>

            {/* Logos section */}
            <Grid size={{ xs: 12 }}>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}>
                Personalización (Logos)
              </Typography>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>Logo Dispositivo</Typography>
                  <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, textAlign: 'center', bgcolor: '#fcfcfc', minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <SurveyImage imageName={(device.logoDevice && typeof device.logoDevice === 'object') ? device.logoDevice.imgName : device.logoDevice} />
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>Logo Calidad</Typography>
                  <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1, textAlign: 'center', bgcolor: '#fcfcfc', minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <SurveyImage imageName={(device.logoQuality && typeof device.logoQuality === 'object') ? device.logoQuality.imgName : device.logoQuality} />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {device.isUserRequired === 1 && (
              <Grid size={{ xs: 12 }}>
                <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>
                  Asignación de Usuarios 
                  {device.isSingleUser === 1 ? ' (Individual)' : device.isMultiUser === 1 ? ' (Múltiple)' : ''}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {device.allUsers === 1 ? (
                    <Chip label="Asignado a todos los usuarios" variant="outlined" color="info" sx={{ fontWeight: 600 }} />
                  ) : (
                    device.users && device.users.length > 0 ? (
                      device.users.map((u: any, index: number) => (
                        <Chip key={index} label={u.label || u} size="small" variant="outlined" />
                      ))
                    ) : (
                      <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                        Sin usuarios específicos asignados
                      </Typography>
                    )
                  )}
                </Box>
              </Grid>
            )}
          </Grid>

        ) : (
          <Typography>Cargando detalle...</Typography>
        )}
      </DialogContent>
    </BootstrapDialog>
  );
}
